import { Card, Modal } from 'antd';
import { useEffect, useState } from 'react';
import { apiPHP } from '../../../../services/api';
import { Card as CustomCard } from './components/Card';
import {
  Content,
  CustomButton,
  FooterContainer,
  ModalContainer,
  EmptyCommentsCard,
} from './styles';

import owlImg from '../../../../assets/img/pet/corujaProfessoraMaoNaCintura.png';

interface CommentProps {
  id: number;
  autor: {
    id: number;
    name: string;
    sobrenome: string;
    foto: string;
  };
  comentario: string;
  tempo_passado: string;
}

interface CommentsModalProps {
  isOpen: boolean;
  gameId: number;
  closeModal: () => void;
  updatePassatemposCommentsCount: () => void;
}

export const CommentsModal = ({
  isOpen,
  closeModal,
  gameId,
  updatePassatemposCommentsCount,
}: CommentsModalProps) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isButtonLoading, setIsButtonLoading] = useState(false);
  const [comments, setComments] = useState<CommentProps[]>([]);

  const [newComment, setNewComment] = useState('');

  useEffect(() => {
    try {
      setIsLoading(true);
      if (gameId !== 0) {
        const getComments = async () => {
          const response = await apiPHP.get(
            `/comentarios/passatempos/${gameId}`
          );

          setComments(response.data.data);
          setIsLoading(false);
        };

        getComments();
      }
    } catch (err) {
      console.log(err);
      setIsLoading(false);
    }
  }, [gameId]);

  const handleSendComment = async () => {
    if (newComment !== '') {
      try {
        setIsButtonLoading(true);
        await apiPHP.post('/comentarios', {
          comentario: newComment,
          destino_passatempos_id: gameId,
        });

        updatePassatemposCommentsCount();
        setNewComment('');
        setIsButtonLoading(false);
      } catch (err) {
        console.log(err);
        setIsButtonLoading(false);
      }
    }
  };

  return (
    <ModalContainer>
      <Modal
        visible={isOpen}
        onCancel={closeModal}
        footer={[
          <FooterContainer key="footerContainer">
            <input
              value={newComment}
              type="text"
              placeholder="Escreva um comentário..."
              onChange={(event) => setNewComment(event.target.value)}
              disabled={isLoading}
            />
            <CustomButton
              type="primary"
              onClick={handleSendComment}
              loading={isButtonLoading}
              disabled={isLoading}
              key="submitButton"
            >
              Comentar
            </CustomButton>
          </FooterContainer>,
        ]}
        style={{ top: 30 }}
        bodyStyle={{ padding: 0 }}
      >
        <Content>
          <h1>Comentários</h1>

          <div>
            {isLoading && (
              <>
                <Card
                  loading={true}
                  style={{ width: '80%', marginBottom: 24 }}
                />
                <Card
                  loading={true}
                  style={{ width: '80%', marginBottom: 24 }}
                />
                <Card
                  loading={true}
                  style={{ width: '80%', marginBottom: 24 }}
                />
              </>
            )}
            {!isLoading &&
              comments.length > 0 &&
              comments.map((comment) => (
                <CustomCard comment={comment} key={comment.id} />
              ))}

            {!isLoading && comments.length === 0 && (
              <Card
                style={{
                  width: '80%',
                  marginBottom: 24,
                  border: 0,
                }}
              >
                <EmptyCommentsCard>
                  <img
                    src={owlImg}
                    alt="Coruja professora com mão na cintura"
                  />
                  <p>Seja o primeiro a comentar!</p>
                </EmptyCommentsCard>
              </Card>
            )}
          </div>
        </Content>
      </Modal>
    </ModalContainer>
  );
};
